import React, { useState } from 'react';
import GameFileWorks from './NewYear';
import styled from "styled-components";
import Snow from './components/Snow';
import Menu from './components/Menu';
import ChristmasTree from './ChristmasTree';
import { useParams } from "react-router-dom";
import { ID_TAB_EVENT_NEW_YEAR } from '@config/constants/helper';
import RankTable from './RankTable';
import Instruction from './Instruction';
import PopupLogin from '../NewYearAndChristmas_2024/Components/PopupLogin';
import iconMenu from "../../../assets/images/Event-2025/image 37 (1).png";
import { useQuery } from 'react-query';
import { getCheckStatusEvent } from 'dataLayer/product';
import Congratulation from './Congratulation';
import { useHistory } from "react-router-dom";
import { PATHS } from '@config/constants';
import { useEffect } from 'react';

export default function NewYearAndChristmas_2025() {
  const { id } = useParams();
  const [openModalLogin, setOpenModalLogin] = useState(false);
  const { data: statusEvent } = useQuery(getCheckStatusEvent());
  const history = useHistory();

  const handleGetTab = () => {
    if (statusEvent?.is_finished) {
      switch (id) {
        case ID_TAB_EVENT_NEW_YEAR.rankTable:
          return <RankTable />;
        case ID_TAB_EVENT_NEW_YEAR.instruction:
          return <Instruction />;
        case ID_TAB_EVENT_NEW_YEAR.congratulation:
          return <Congratulation statusEvent={statusEvent}/>;
        default:
          return;
      }
    } else {
    switch (id) {
      case ID_TAB_EVENT_NEW_YEAR.gameFireworks:
        return <GameFileWorks setOpenModalLogin={setOpenModalLogin} />;
      case ID_TAB_EVENT_NEW_YEAR.christmasTree:
        return <ChristmasTree setOpenModalLogin={setOpenModalLogin} />;
      case ID_TAB_EVENT_NEW_YEAR.instruction:
        return <Instruction />;
      case ID_TAB_EVENT_NEW_YEAR.rankTable:
        return <RankTable />;
      // case ID_TAB_EVENT_NEW_YEAR.specialCode:
      //   return <SpecialCode setOpenModalLogin={setOpenModalLogin} />;
      default:
          return;
      }
    }
  }

  useEffect(() => { 
    if (+statusEvent?.is_show === 0) {
       history.push(PATHS.HOME_PAGE)
    }
  }, [statusEvent?.is_show])

  
  return (
    // <div><GameFileWorks /></div>
    <>
      <Div className='even-2025__dark-mode'>
        <div className="icon-menu-head">
          <img src={iconMenu} alt="" />
        </div>
        <div className="container-detail-event">
        <div className='container-menu__event-2025'>
          <Menu statusEvent={statusEvent}/></div>
          {handleGetTab()}
        </div>
        <Snow />
      </Div>
      <PopupLogin open={openModalLogin} setOpen={setOpenModalLogin} />
    </>
  )
}

const Div = styled.div`
  .container-menu__event-2025{
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }
  p{
    color: #292524;
    margin-bottom: 0;
    line-height: 100%;
  }
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  margin: 20px 0;

  .container-animation-snow {
    margin-top: 74px;
  }

  #id-now-container {
    width: 100%;
    height: calc(100% - 74px);
    margin-top: 74px;
    position: absolute;
    top: 0;
    pointer-events: none;
  }

  .position-relative {
    position: relative;
  }

  .container-main-event-2024 {
    width: 100%;
    height: calc(100% - 74px);
    position: relative;
  }

  .container-detail-event {
    position: relative;
    width: 100%;
    height: 100%;

    /* overflow-y: hidden; */
    /* overflow: hidden; */
    z-index: 1;
  }

  .icon-menu-head {
    position: absolute;
    pointer-events: none;
    top: 50px;
    z-index: 2;
    width: calc(100% + 80px);
    left: -45px;

    img {
      width: calc(100% + 90px);
    }
  }

   @media (max-width: 1600px) {
    .icon-menu-head {
      top: 50px;
    }
   }

  @media (max-width: 1400px) {
    .icon-menu-head {
      position: absolute;
      top: 36px;
      z-index: 2;
      width: calc(100% + 45px);
      left: -25px;

      img {
        height: 100px;
      }
    }
    .container-main-event-2024 {
      height: calc(100% - 60px);
    }
  }

  @media (max-width: 992px) {
    height: calc(100% + 120px);
    padding-bottom: 120px;
    margin-top: 20px;
  }

  @media (max-width: 576px) {
    margin-top: 10px;

    .icon-menu-head img {
      height: 70px;
    }

    .icon-menu-head{
      top: 50px;
    }

   .custom-next-event{
      right: 2px;
    }

    .custom-prev-event{
      left: 2px;
    }

    .btn-custom-event {
      padding: 0;
      span {
        width: 12px;
      }
    }
  }
`;
